import React from "react";
import { useField, useFormikContext, ErrorMessage } from "formik";
import TimePicker from "react-time-picker";

import moment from "moment";


export const TimePickerField = ({ ...props }) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);

    return (
        <div className="form-group">
            {/*<label for={props.name}>{props.name}</label>*/}
            <TimePicker
                label={props.label}
                format={"hh:mma"}
                {...field}
                selected={(field.value && new Date(field.value) || null)}
                onChange={val => {
                    setFieldValue(field.name, val);
                }}
                minutePlaceholder="  "
                hourPlaceholder="  "
                clearIcon={null}
                clockIcon={null}
                disableClock={true}
                nativeInputAriaLabel={props.label}
                amPmAriaLabel="Select AM/PM"
                hourAriaLabel="Hour"
                minuteAriaLabel="Minute"
                disabled={props.disabled}
                clearAriaLabel="Clear value"
            />
            <ErrorMessage name={props.name} component="div" />
        </div>
    );
};

export default TimePickerField;